import deep from 'deep-get-set';
import { 
  createAction,
} from 'redux-api-middleware';
import {
  createSelector,
} from 'reselect';

import config from '../../config';
import {
  MEDIA_DETAIL_LOAD_SUCCESS,
} from './media';
import { buildHeaders } from '../buildAuthHeader';

// Action helpers
export function clearSelectedTagsFailed() {
  return {
    type: SELECTED_TAGS_PUT_FAILURE_CLEAR
  }
}

// Actions
export const SELECTED_TAGS_PUT = 'SELECTED_TAGS_PUT';
export const SELECTED_TAGS_PUT_SUCCESS = 'SELECTED_TAGS_PUT_SUCCESS';
export const SELECTED_TAGS_PUT_FAILURE = 'SELECTED_TAGS_PUT_FAILURE';
export const SELECTED_TAGS_PUT_FAILURE_CLEAR = 'SELECTED_TAGS_PUT_FAILURE_CLEAR';
export const ALL_TAGS_LOAD = 'ALL_TAGS_LOAD';
export const ALL_TAGS_LOAD_SUCCESS = 'ALL_TAGS_LOAD_SUCCESS';
export const ALL_TAGS_LOAD_FAILURE = 'ALL_TAGS_LOAD_FAILURE';

export const fetchAllTags = () => createAction({
  endpoint: `${config.apiHost}${config.endpoints.tags}`,
  method: 'GET',
  headers: buildHeaders(),
  credentials: 'include',
  types: [
    ALL_TAGS_LOAD,
    ALL_TAGS_LOAD_SUCCESS,
    ALL_TAGS_LOAD_FAILURE,
  ],
});

export const putSelectedTags = (mediaId, tags, newTags = []) => createAction({
  endpoint: `${config.apiHost}${config.endpoints.media}/${mediaId}/tags`,
  method: 'PUT',
  headers: buildHeaders(),
  credentials: 'include',
  body: JSON.stringify({
    tags,
    newTags,
  }),
  types: [
    SELECTED_TAGS_PUT,
    SELECTED_TAGS_PUT_SUCCESS,
    SELECTED_TAGS_PUT_FAILURE,
  ],
});

// Initial State
const initialState = {
  isAllTagsLoading: false,
  isAllTagsLoaded: false,
  isAllTagsLoadedFailed: false,
  isPutSelectedTagsFailed: false,
  selectedTags: [],
  allTags: [],
};

// Reducers
export function tagsReducer(state = initialState, action) {
  switch (action.type) {

    case SELECTED_TAGS_PUT_FAILURE: {
      const newState = {
        ...state,
        isPutSelectedTagsFailed: true,
      }

      return newState;
    }

    case SELECTED_TAGS_PUT_FAILURE_CLEAR: {
      const newState = {
        ...state,
        isPutSelectedTagsFailed: false,
      }

      return newState;
    }

    case ALL_TAGS_LOAD: {
      const newState = {
        ...state,
        isAllTagsLoading: true,
      }

      return newState;
    }

    case ALL_TAGS_LOAD_FAILURE: {
      const newState = {
        ...state,
        isAllTagsLoading: false,
      }

      return newState;
    }

    case ALL_TAGS_LOAD_SUCCESS: {
      const newState = {
        ...state,
        isAllTagsLoading: false,
        allTags: action.payload.map(tag => ({
          label: tag.name,
          value: tag.id,
        })),
      }
      return newState;
    }

    case SELECTED_TAGS_PUT_SUCCESS: {
      const newState = {
        ...state,
        selectedTags: action.payload.data.tags.map(tag => tag.id),
      }
      return newState;
    }

    case MEDIA_DETAIL_LOAD_SUCCESS: {
      const newState = {
        ...state,
        selectedTags: action.payload.data.tags.map(tag => tag.id)
      }
      return newState;
    }

    default: {
      return state;
    }
  }
}


// Selectors
export const getTags = createSelector(
    state => state,
    state => state.get('tags'),
);

export const getAllTags = createSelector(
    getTags,
    tags => deep(tags, 'allTags'),
);

export const getSelectedTags = createSelector(
    getTags,
    tags => deep(tags, 'selectedTags'),
);

export const getIsAllTagsLoading = createSelector(
    getTags,
    tags => deep(tags, 'isAllTagsLoading'),
);

export const getIsPutSelectedTagsFailed = createSelector(
    getTags,
    tags => deep(tags, 'isPutSelectedTagsFailed'),
);




// WEBPACK FOOTER //
// ./src/redux/modules/tags.js